export const NotFoundElement = () => {
    return (
        <>
            <div id="main">
                <div className="fof">
                    <h1>You do not have permission to view this page.</h1>
                </div>
            </div>
        </>
    );
}